var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.57328 6.31372L2.81953 10.4443C2.76317 10.4786 2.69878 10.4973 2.63286 10.4987C2.56694 10.5001 2.50182 10.4841 2.44406 10.4523C2.3863 10.4205 2.33795 10.374 2.30388 10.3176C2.26981 10.2611 2.25122 10.1967 2.25 10.1308V1.8695C2.25122 1.80358 2.26981 1.73914 2.30388 1.68269C2.33795 1.62624 2.3863 1.57977 2.44406 1.54797C2.50182 1.51617 2.56694 1.50016 2.63286 1.50155C2.69878 1.50294 2.76317 1.52169 2.81953 1.55591L9.57328 5.68653C9.62723 5.71918 9.67184 5.7652 9.7028 5.82014C9.73377 5.87507 9.75004 5.93707 9.75004 6.00013C9.75004 6.06319 9.73377 6.12518 9.7028 6.18011C9.67184 6.23505 9.62723 6.28107 9.57328 6.31372Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1437 5.36695L3.39 1.23539C3.27613 1.16567 3.14572 1.1276 3.01222 1.12513C2.87873 1.12266 2.74699 1.15587 2.63063 1.22133C2.51536 1.28577 2.41935 1.37976 2.35245 1.49361C2.28556 1.60747 2.25019 1.73709 2.25 1.86914V10.1313C2.25087 10.3294 2.33036 10.519 2.471 10.6585C2.61164 10.798 2.80191 10.876 3 10.8752C3.13826 10.8752 3.27383 10.8371 3.39188 10.7651L10.1437 6.63351C10.2523 6.56736 10.342 6.47441 10.4042 6.36359C10.4664 6.25277 10.4991 6.1278 10.4991 6.0007C10.4991 5.8736 10.4664 5.74864 10.4042 5.63781C10.342 5.52699 10.2523 5.43404 10.1437 5.36789V5.36695ZM3 10.1224V1.87523L9.74203 6.00023L3 10.1224Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/PlayIcon.1e5644c4d025a371690c45c007ec1dd2.svg";
export { ForwardRef as ReactComponent };